import { render, staticRenderFns } from "./panelAgua.vue?vue&type=template&id=5179b486&"
import script from "./panelAgua.vue?vue&type=script&lang=js&"
export * from "./panelAgua.vue?vue&type=script&lang=js&"
import style0 from "./panelAgua.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports